/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class LocalizationService {
    /** @ngInject */
    constructor($http, $log, url) {
        this.$http = $http;
        this.$log = $log;
        this.url = url;
        this.$log.debug('Service \'LocalizationService\' loaded');
    }

    findLocationByAddress(address) {
        return this.$http({
            method: 'GET',
            url: this.url,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': undefined
            },
            params: {
                q: address,
                format: 'json'
            }
        }).then(response => {
            return {
                latitude: parseFloat(response.data[0].lat),
                longitude: parseFloat(response.data[0].lon)
            };
        });
    }
}

export { LocalizationService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/LocalizationService.js